import styled from '@emotion/styled';
import Popover from 'react-popover';
import Button from '../../Button';

export const DeleteConfirmPopover = styled(Popover)`
  border-radius: 3px;
  z-index: 9999;
  & > .Popover-tip {
    fill: rgba(255, 255, 255, 0.9);
    overflow: visible;
  }
`;

export const DeleteConfirmWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  background: #fff;
  border-radius: 3px;
  border: ${({ shouldShowBorder }) =>
    shouldShowBorder ? '1px solid #ccc!important' : 'none'};
`;

export const DeleteWorklogButton = styled(Button)`
  box-shadow: none;
  margin: 0;
`;

export const DeleteButton = styled.button`
  border-radius: 3px;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 8px 4px 0 0;
  padding: 6px 12px;
  text-align: center;
  -webkit-appearance: none;
  background-color: #cf513d;
  color: #ffffff;
  box-shadow: none;
  border: none;

  &:hover {
    background-color: #eb5a46;
  }

  &:focus {
    outline: 0;
    box-shadow: none;
    border: none;
  }
`;

export const CancelButton = styled.button`
  border-radius: 3px;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 8px 4px 0 0;
  padding: 6px 12px;
  text-align: center;
  -webkit-appearance: none;
  background-color: rgba(9, 30, 66, 0.04);
  border: none;

  &:hover {
    background: linear-gradient(rgb(226, 228, 230) 0%, rgb(214, 218, 220) 100%);
    color: rgb(77, 77, 77);
  }

  &:focus {
    outline: 0;
    background-color: rgba(9, 30, 66, 0.08);
    box-shadow: none;
    border: none;
  }
`;

export const DeleteConfirmTitle = styled.span`
  padding: 12px 5px 0 12px;
`;

export const DeleteConfirmButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
`;
